import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SEOMetadata from '../components/SEOMetadata';

const NotFoundPage = () => (
  <div className="public-page">
    <SEOMetadata title="Страница не найдена" description="Запрошенная страница не существует." path="/404" noindex />
    <Header />
    <main className="nocturne-not-found">
      <div><strong>404</strong><h1>Здесь ничего нет</h1><p>Возможно, адрес изменился или в ссылке есть ошибка. Вернитесь на главную страницу.</p><Link className="nocturne-button primary large" to="/"><ArrowLeft size={17} /> На главную</Link></div>
    </main>
    <Footer />
  </div>
);

export default NotFoundPage;
